// extracted by mini-css-extract-plugin
export var actionButton = "_98-1";
export var actionButtons = "_98-2";
export var actions = "_98-0";
export var aiUnread = "_98-10";
export var alignCenter = "_98-h";
export var backWrapper = "_98-3";
export var cellContainer = "_98-4";
export var checkboxContainer = "_98-5";
export var contentContainer = "_98-6";
export var contentHeader = "_98-8";
export var conversationsTableWrapper = "_98-s";
export var draftReplyBadgeContainer = "_98-m";
export var dropdownItem = "_98-b";
export var dropdownItemsContainer = "_98-a";
export var dropdownTitle = "_98-c";
export var errorIcon = "_98-7";
export var filter = "_98-d";
export var gray = "_98-i";
export var headerActionButtons = "_98-e";
export var headerCheckboxContainer = "_98-f";
export var icon = "_98-j";
export var menuContainer = "_98-k";
export var noMoreTicketsIcon = "_98-12";
export var noMoreTicketsSubText = "_98-13";
export var oneLine = "_98-l";
export var optionsButton = "_98-n";
export var plus = "_98-o";
export var portalButtonsWrapper = "_98-g";
export var red = "_98-p";
export var scrolledTop = "_98-9";
export var search = "_98-q";
export var selectedConversationsCount = "_98-r";
export var spinner = "_98-t";
export var strong = "_98-u";
export var summaryCell = "_98-v";
export var tableContainer = "_98-11";
export var tagContainer = "_98-w";
export var threeDots = "_98-x";
export var twoLines = "_98-y";
export var unread = "_98-z";